<template>
<div>

  <h1 class="text-center p-t-lg immoapp__intro">{{ $t("Vereinbaren Sie jetzt einen Besichtigungstermin") }}</h1>

  <div class="row">
    <div class="col-24 col-md-12 col-lg-14">
      <div v-if="date == null">
        <h3 class="mt-4">Alle verfügbaren Termine</h3>
        <ul class="immoapp__available-appointments">
          <li v-for="(spot, index) in allSpots" :key="index">
            <a @click="click(spot.startTime)">
              <span class="fal fa-calendar-day"></span> <span class="mr-8">{{ spot.startTime | moment("L") }}</span>
                <span class="fal fa-clock"></span> {{ spot.startTime | moment("hhmm") }}&nbsp;Uhr
            </a>
          </li>
        </ul>
      </div>

      <div v-else>
        <h3 class="mt-4">Termine am {{ date | moment }}</h3>
        <ul class="immoapp__available-appointments">
          <li v-for="(spot, index) in spots" :key="index">
            <a @click="click(spot.startTime)">
              <span class="fal fa-calendar-day"></span> <span class="mr-8">{{ spot.startTime | moment("L") }}</span>
                <span class="fal fa-clock"></span> {{ spot.startTime | moment("hhmm") }}&nbsp;Uhr
            </a>
          </li>
        </ul>
      </div>

      <div class=" p-t-lg">
        <v-date-picker
          locale="de-DE"
          v-model="date"
          :picker-date.sync="pickerDate"
          :allowed-dates="allowedDates"
          full-width
          :landscape="$vuetify.breakpoint.smAndUp"
        ></v-date-picker>
      </div>
    </div>

    <div class="col-24 col-md-12 col-lg-8 offset-lg-2">
      <div class="immolisting">
        <expose :item="expose" />
      </div>
    </div>
  </div>

  <confirm v-model="confirm" okButtonText="bestätigen">
    <template #default="slotProps">
      Möchten Sie den Termin am {{ slotProps.data.startTime | moment("long") }} verbindlich bestätigen?
    </template>
  </confirm>
</div>
</template>

<script>
import Confirm from "./Confirm.vue";
import Expose from "./Expose";

export default {
  name: "ExposeCalendarScheduler",

  components: {
    Confirm,
    Expose
  },

  data() {
    return {
      date: null, //new Date().toISOString().substr(0, 10),
      pickerDate: null,
      confirm: true
    };
  },

  props: [
    "days",
    "expose"
  ],

  computed: {
    spots() {
      const date = this.days.find(d => d.date == this.date);
      if (!date) {
        return [];
      }

      return date.spots;
    },

    allSpots() {
      const spots = [];

      this.days.forEach(d => {
        d.spots.forEach(s => {
          spots.push(s);
        });
      });

      return spots;
    }
  },

  created() {
    this.$store.dispatch("appData", {"title": this.$t("Besichtigungstermin vereinbaren")});
  },

  methods: {
    allowedDates(val) {
      return this.days.find(d => d.date == val);
    },

    click(startTime) {
      this.confirm = {
        title: "Termin bestätigen",
        data: {
          startTime
        },
        ok: () => {
          this.$store.dispatch("expose/createCalendarAppointment", {
            exposeId: this.expose.exposeId,
            start: startTime
          }).then(() => {
            this.$store.dispatch("expose/loadCalendar", { exposeId: this.expose.exposeId, force: true });
          });
        }
      };
    }
  }
};
</script>
